import {
    GET_ANALYSE_MARGE_TOTAUX,
    GET_ANALYSE_MARGE_CLASSES,
    GET_ANALYSE_MARGE_DETAILS,
    GET_ANALYSE_MARGE_EFFICACITE,
    GET_ANALYSE_MARGE_TOTAUX_LIVRES,
    GET_ANALYSE_MARGE_CLASSES_LIVRES,
    GET_ANALYSE_MARGE_DETAILS_LIVRES,
    GET_ANALYSE_MARGE_EFFICACITE_LIVRES
} from '../actions/action-types';

const initialState = {
    totaux: null,
    classes: [],
    details: [],
    efficaciteData: [],
    totauxLivres: null,
    classesLivres: [],
    detailsLivres: [],
    efficaciteDataLivres: []
};

export default function analyseMarges(state = initialState, action) {
    switch (action.type) {
        case GET_ANALYSE_MARGE_TOTAUX:
            return {
                ...state,
                totaux: action.payload
            };
            
        case GET_ANALYSE_MARGE_CLASSES:
            return {
                ...state,
                classes: action.payload || []
            };
            
        case GET_ANALYSE_MARGE_DETAILS:
            return {
                ...state,
                details: action.payload || []
            };
            
        case GET_ANALYSE_MARGE_EFFICACITE:
            return {
                ...state,
                efficaciteData: action.payload || []
            };

        case GET_ANALYSE_MARGE_TOTAUX_LIVRES:
            return {
                ...state,
                totauxLivres: action.payload
            };
            
        case GET_ANALYSE_MARGE_CLASSES_LIVRES:
            return {
                ...state,
                classesLivres: action.payload || []
            };
            
        case GET_ANALYSE_MARGE_DETAILS_LIVRES:
            return {
                ...state,
                detailsLivres: action.payload || []
            };
            
        case GET_ANALYSE_MARGE_EFFICACITE_LIVRES:
            return {
                ...state,
                efficaciteDataLivres: action.payload || []
            };
            
        default:
            return state;
    }
}